import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class ParamService {
  private _source = new BehaviorSubject("");
  currentMessage = this._source.asObservable();
  


  Parameterpass(param: string) {
    this._source.next(param)
  }


  // Observable string sources
  private emitDashboardSource = new Subject<any>();
  // Observable string streams
  changeEmitted$ = this.emitDashboardSource.asObservable();
   emitDashboardChange(message: boolean) {
    this.emitDashboardSource.next(message);
   }
clearData() {
    this.emitDashboardSource.next(null);
}







}
